import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SupplierService {
    constructor(private http: HttpClient) {}

    public approveCampaign(id: string) {
        return this.http.post<any>(`${environment.apiUrl}/supplier/approve-campaign/${id}`, null);
    }

    public rejectCampaign(id: string, reason: string) {
        return this.http.post<any>(`${environment.apiUrl}/supplier/reject-campaign/${id}`, {
            rejectReason: reason
        });
    }
}
